module.exports = __webpack_public_path__ + "img/login_slogan_es.adb04660.png";